import React, { Component } from 'react'

import PropTypes from 'prop-types'

import ImageJuxtBodyComponent from './component'

const NEW_LINE = '\n'
const STRING_TO_REPLACE = /\\\\n/g
const MAX_LINES = 2

export const splitTextIntoLines = text => {
  if (typeof text !== 'string') {
    return null
  }

  try {
    //Use the first two lines of whatever text is passed into this component.
    const textElements = text
      .replace(STRING_TO_REPLACE, NEW_LINE) //H5P newlines come in as \\n. Replace with \n
      .split(NEW_LINE)
      .filter(Boolean)
      .slice(0, MAX_LINES)

    return textElements.length > 0 ? textElements : null
  } catch (error) {
    return null
  }
}

class ImageJuxtBodyContainer extends Component {
  splitTextIntoLines = () => splitTextIntoLines(this.props.text)

  render = () => {
    const textElements = this.splitTextIntoLines()

    if (!textElements) {
      return null
    }

    return <ImageJuxtBodyComponent textElements={textElements} />
  }
}

ImageJuxtBodyContainer.propTypes = {
  text: PropTypes.string,
}

ImageJuxtBodyContainer.defaultProps = {
  text: '',
}

export default ImageJuxtBodyContainer
